"use client"

import { useState } from "react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { Menu, X, Recycle } from "lucide-react"
import { DemoModal } from "@/components/demo-modal"

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <nav className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary">
              <Recycle className="w-6 h-6 text-primary-foreground" />
            </div>
            <span className="text-xl font-bold tracking-tight text-foreground">
              TRD Solutions
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <Link href="#solucoes" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Soluções
            </Link>
            <Link href="#recursos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Recursos
            </Link>
            <Link href="#sobre" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Sobre
            </Link>
            <Link href="#contato" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              Contato
            </Link>
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <Button variant="ghost" className="text-muted-foreground hover:text-foreground">
              Entrar
            </Button>
            <DemoModal>
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
                Solicitar Demo
              </Button>
            </DemoModal>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-foreground"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-4">
              <Link href="#solucoes" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Soluções
              </Link>
              <Link href="#recursos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Recursos
              </Link>
              <Link href="#sobre" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Sobre
              </Link>
              <Link href="#contato" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Contato
              </Link>
              <div className="flex flex-col gap-2 pt-4 border-t border-border">
                <Button variant="ghost" className="justify-start text-muted-foreground">
                  Entrar
                </Button>
                <DemoModal>
                  <Button className="bg-primary text-primary-foreground">
                    Solicitar Demo
                  </Button>
                </DemoModal>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
